import * as React from "react";
import Content from "../../../Content";
import Axios from "../../Components/Axios";
import {Link} from "react-router-dom";

class Add extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            kp_msisdn: '',
            errors: {
                title: true,
                kp_msisdn: true
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        Axios
            .post('api/kp/add', {
                title: this.state.title,
                kp_msisdn: this.state.kp_msisdn
            })
            .then(r => (r?.success && this.props.history.push('/admin/kp')))
            .catch(() => this.props.history.push('/'));
    }

    handleChange(e, field) {
        this.setState({
            [field]: e.target.value
        })
    }

    isNumberCorrect(value) {

        if(!/^996[0-9]{9}/.test(value)) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    kp_msisdn: true
                }
            }));
            return;
        }

        Axios
            .get('/api/check_msisdn/' + value)
            .then(r => this.setState(prev => ({
                    errors: {
                        ...prev.errors,
                        kp_msisdn: !r?.success
                    }
                }))
            );
    }

    render() {
        return (
            <Content title="Добавление КП">
                <div className="row mb-3">
                    <div className="col d-flex justify-content-between align-items-center">
                        <h5>Добавление контент-провайдера</h5>
                    </div>
                </div>
                <div className="row my-3">
                    <div className="col-12">
                        <Link className="btn btn-light mr-4" to={'/admin/kp'}>← Назад</Link>
                    </div>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label>Контент провайдер</label>
                        <input
                            className={"form-control " + (this.state.errors.title ? 'is-invalid' : '')}
                            placeholder="ОсОО ТВ Клик"
                            value={this?.state?.title}
                            onChange={e => {
                                this.setState(prev => ({
                                    errors: {
                                        ...prev.errors,
                                        title: !e.target.value?.length
                                    }
                                }));
                                this.handleChange(e, 'title');
                            }}
                            title={ this.state.errors.title ? 'Поле не может быть пустым' : '' }
                            maxLength={25}
                        />
                    </div>
                    <div className="form-group">
                        <label>Номер КП</label>
                        <input
                            className={"form-control " + (this.state.errors.kp_msisdn ? 'is-invalid' : '')}
                            placeholder="996555112233"
                            value={this?.state?.kp_msisdn}
                            onChange={e =>{ this.isNumberCorrect(e.target.value); return this.handleChange(e, 'kp_msisdn') } }
                            title={ this.state.errors.title ? 'Поле телефона имеет недопустимый формат или недопустимый номер' : '' }
                            maxLength={12}
                        />
                    </div>
                    <div className="form-group">
                        <button
                            className="btn btn-success"
                            type="submit"
                            disabled={ this.state.errors.kp_msisdn || this.state.errors.title }
                        >
                            Добавить
                        </button>
                        <Link
                            to={'/admin/kp'}
                            className="btn btn-danger ml-2"
                        >
                            Отмена
                        </Link>
                    </div>
                </form>
            </Content>
        );
    }
}

export default Add;